import React from 'react';

import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { makeGuardedModal, GuardedModalContentComponentProps } from 'components/guardedModal/makeGuardedModal';
import styles from './ActionLogDetailsModal.module.scss';

type ActionLogDetailsModal = GuardedModalContentComponentProps<{ action: string; data: string }>;

const LogDetails = ({ data: { action, data } }: ActionLogDetailsModal) => {
  return (
    <AppModal id={SimpleModalId.LogDetails} title={`Details - ${action}`} hideActionButtons hideOpenButton>
      <pre className={styles.json}>{JSON.stringify(data, null, 2)}</pre>
    </AppModal>
  );
};

export const ActionLogDetailsModal = makeGuardedModal(SimpleModalId.LogDetails, LogDetails);
